module.exports = __webpack_public_path__ + "static/media/seguradora_chubb.c2f9333c.jpg";